import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";
// import "swiper/swiper-bundle.css";
// import 'swiper/css/swiper.css';  
// import 'react-id-swiper/lib/styles/css/swiper.css'
export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
  if (props.page == "dr-carousel-unit") {
    params = {
      loop: true,
      pagination: {
        el: elePagi,
        clickable: true
      },
      autoplay: {
        delay: 5500,
        disableOnInteraction: false
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  } else if (props.page == "dr-carousel-unit1") {
    params = {
      loop: false, // Disable loop to avoid white space at end with bullets
      slidesPerView: window.innerWidth >= 768 ? 4 : 3,
      spaceBetween: window.innerWidth >= 768 ? 30 : 15,
      pagination: {
        el: elePagi,
        clickable: true,
        type: "bullets"
      },
      autoplay: {
        delay: 5500,
        disableOnInteraction: false
      },
      getSwiper: updateSwiper
    };
  } else {
    params = {
      loop: true,
      pagination: {
        el: elePagi,
        clickable: true
      },
      autoplay: {
        delay: 5500,
        disableOnInteraction: false
      },
      getSwiper: updateSwiper // Get swiper instance callback
    };
  }

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));

      if (swiper.autoplay && !swiper.autoplay.running) {
        swiper.autoplay.start();
      }
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  // const getFinalUrl = (url) => {
  //   // console.log("getfinalurl===", url);
  //   try {
  //     if (window.appendRefToUrl) {
  //       return window.appendRefToUrl(url);
  //     }
  //     return url; // fallback
  //   } catch (e) {
  //     return url;
  //   }
  // };

  // helper: get cookie
const getCookie = (name) => {
  try {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  } catch (e) {}
  return null;
};

// your ref builder
const buildRefValue = (url) => {
  let value = null;

  // 1. current page ref
  try {
    const currentUrl = new URL(window.location.href);
    const currentRef = currentUrl.searchParams.get("ref");

    if (currentRef) {
      value = currentRef;
    }
  } catch (e) {}

  // 2. cookie fallback
  if (!value) {
    const cookieRef = getCookie("tracking_ref");
    if (cookieRef) {
      value = cookieRef;
    }
  }

  // 3. final format
  if (value) {
    return `parenting_homepage_${value}`;
  }

  return "parenting_homepage";
};

// final URL builder
const getFinalUrl = (url) => {
  try {
    const parsedUrl = new URL(url, window.location.origin);

    const refValue = buildRefValue(url);

    // remove old ref
    parsedUrl.searchParams.delete("ref");

    // add new ref
    if (refValue) {
      parsedUrl.searchParams.set("ref", refValue);
    }

    return parsedUrl.toString();
  } catch (e) {
    return url;
  }
};

  return (
    <div>
     <ReactIdSwiper {...params}>
  {data.map((item, idx) => {
    const finalUrl = getFinalUrl(item.redirectUrl);
    if (props.page == "dr-carousel-unit") {
      return (
        <div className="swiper-slide_feed" key={idx}>
          <div className="dr-cont-main">
            <div className="dr-photo">
              <a href={item.redirectUrl} tabIndex={0} aria-label={`Go to ${item.imageTitle}`}>
                <img data-key={idx} className="topBannerImg" src={item.bannarImage} alt={item.imageAlt} title={item.imageTitle}/>
              </a>
            </div>
          </div>
        </div>
      );
    } else if (props.page == "dr-carousel-unit1") {
      return (
        <div className="swiper-slide_fc_corner" key={idx}>
            <a href={finalUrl} className="gtmValues" data-title={item.title} data-catid={item.id} data-index={idx} data-pageurl={finalUrl} tabIndex={0} aria-label={`Go to ${item.title}`}>
              <div className="dr-cont-main">
                  <img className="fcBannerImg" src={item.imageUrl} alt={`Product - ${item.title}`} title={item.title} />
                <p className="R15_21 product-title">{item.title}</p>
             </div>
            </a>
        </div>
      );
    } else {
      return (
        <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" alt="" />
              </div>
      );
    }
  })}
</ReactIdSwiper>

      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev} aria-label="Previous Slide">
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext} aria-label="Next Slide">
          Next
        </button>
      </div>
    </div>
  );
};
